// hides new sequence_created link
$(document).ready(  function() {
  $('#new_sequence_created_link').hide();
});
